namespace Roodik.Game
{
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import ViewBase = Roodik.Core.ViewBase;
	import ISoundManager = Roodik.Core.ISoundManager;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAnalytics = Roodik.Core.IAnalytics;
	import IAdvertisment = Roodik.Core.IAdvertisment;

	export class IntroPanel extends ViewBase
	{
		public static readonly PLAY: string = "Intro.Play";
		public events: PIXI.utils.EventEmitter;
		private _startButton3: SimpleButton;
		private _tweenHide:Tween;
		private _message:PIXI.Text;

		constructor(private _localizationManager:LocalizationManager,
		            private _soundManager:ISoundManager,
		            private _analytics:IAnalytics,
		            private _ad:IAdvertisment)
		{
			super("IntroPanel");

			this.events = new PIXI.utils.EventEmitter();
			this._startButton3 = new SimpleButton(this.childByName("Button").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_PLAY), {
				fontFamily: 'WellWait',
				fontSize: 30,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,
				
				padding:20
			});
			this._startButton3.events.on(SimpleButton.CLICKED, ()=>{
				this.onSubmitButtonClicked(LevelDifficulty.Easy);
			});

			this._soundManager.playMusic("music.mp3", 0.3);
		}

		private onSubmitButtonClicked(difficulty:LevelDifficulty): void
		{
			this._soundManager.playSound("click.mp3", 1);

			this._analytics.sendEvent("Game","Start","");

			if (this._ad.available)
			{
				let runGameCallback = ()=>{
					this.startGame(difficulty);
					this._ad.resumeGameEvent.off(runGameCallback);
					runGameCallback = null;
				}
				this._ad.resumeGameEvent.on(runGameCallback);

				this._ad.show(true);
			}
			else
			{
				this.startGame(difficulty);
			}
		}

		private startGame(difficulty:number)
		{
			this._tweenHide = new Tween(this)
			.to({alpha: 0.8}, 150)
			.easing(Easing.Linear.None)
			.onComplete(function ()
			{
				Tween.removeAll();

				this.events.emit(IntroPanel.PLAY, difficulty);
			}.bind(this))
			.start();
		}

		public destroy()
		{
			/*this.removeChild(this._message);
			this._message.destroy();

			this._startButton1.events.off(SimpleButton.CLICKED, this.onSubmitButtonClicked.bind(this));
			this._startButton1.destroy();

			this._startButton2.events.off(SimpleButton.CLICKED, this.onSubmitButtonClicked.bind(this));
			this._startButton2.destroy();

			*/
			
			this._startButton3.events.off(SimpleButton.CLICKED, this.onSubmitButtonClicked.bind(this));
			this._startButton3.destroy();
		}
	}

	export enum LevelDifficulty
	{
		Easy = 0,
		Medium = 1,
		Hard = 2,
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/IntroPanel.ts